// http://confluence.mobvista.com/pages/viewpage.action?pageId=35017746

import _ from 'lodash'
import livePreview from './live-preview.js'
import { cookUpdateImageMessage, baseUrl } from './util.ts'

const getInitState = () => {
  return {
    // 当前场景
    activeScene: 'start',
    iframe: null,
    // 根据 iframe 中 playable 中的 preview_util 脚本发过来的事件更新 gameReady
    // 事件传过来的值 { type: 'previewer:gameReady' }
    gameReady: false,
    canLivePreview: false,
  }
}

const previewer = {
  namespaced: true,

  state: getInitState(),

  mutations: {
    updateIframe(state, iframe) {
      state.iframe = iframe
    },

    resetState(state) {
      Object.assign(state, getInitState())
    },

    updateActiveScene(state, scene) {
      state.activeScene = scene
    },

    gameReady(state, val) {
      state.gameReady = val
    },
  },

  actions: {
    livePreview,

    updateGameReady({ state, commit }, val) {
      commit('gameReady', val)
    },

    updateCanLivePreview({ state }, value) {
      state.canLivePreview = value
    },

    // 由于实时预览与音频暂停播放的处理是不同的团队维护，如果 target 是 previewer 的话，说明该事件是发送给预览组件的
    stopAudio({ dispatch }) {
      dispatch('postMessage', {
        target: 'previewer',
        data: {
          action: 'stop',
          type: 3,
        },
      })
    },

    recoveryAudio({ dispatch }) {
      dispatch('postMessage', {
        target: 'previewer',
        data: {
          action: 'recovery',
          type: 3,
        },
      })
    },

    /**
     * postMessage 发送消息给 iframe，消息为空为不会发送消息
     * @param {any} param0
     * @param {{path: string|string[], url:string|string[], scene: string, type: number, uuid: string}|{target: string, data:{}}} message
     */
    postMessage({ state, commit, dispatch }, message) {
      if (!state.gameReady) {
        console.error('playable has not ready.', message)
        return
      }

      // target 不是发给预览组件且不支持实时预览
      // 因为不支持实时预览的包也支持静音操作
      if (_.get(message, 'target') !== 'previewer' && !state.canLivePreview) {
        console.warn('该素材包不支持实时预览', message)
        return
      }

      // console.log('post message:', message)
      const targetOrigin = '*'
      const iframe =
        state.iframe || document.getElementById('preview-device-iframe')
      const postMessage = (message) => {
        console.log(message)
        iframe &&
          iframe.contentWindow &&
          iframe.contentWindow.postMessage(message, targetOrigin)
      }

      if (message) {
        // 将 ending 改为 end
        if (message.scene === 'ending') {
          message.scene = 'end'
        }
        postMessage(message)
      } else {
        console.warn('message 为空，不会触发 postMessage')
      }
    },

    /**
     * previewImage 实时预览图片
     * @param {any} param0
     * @param {{path:  string, url: string}} message
     */
    previewImage({ state, commit, dispatch }, { path, url }) {
      dispatch(
        'postMessage',
        cookUpdateImageMessage({
          targetResourcePath: path,
          newResourceUrl: url,
          baseUrl,
        }),
      )
    },

    /**
     * previewActiveScene 实时预览某个场景
     * @param {any} param0
     * @param {string} scene
     */
    previewActiveScene({ state, commit, dispatch }, scene) {
      if (['start', 'ending', 'end'].every((item) => item !== scene)) {
        throw new Error('scene 只支持 start/end/ending 之一')
      }
      commit('updateActiveScene', scene)
      dispatch('postMessage', { action: 'navigate', scene })
    },
  },
}

export default previewer
